module.exports = __webpack_public_path__ + "img/bg2.d356a7af.jpeg";